var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasProShows)?_c('webinar-template',{attrs:{"config":_vm.config}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }